module.exports = __webpack_public_path__ + "img/shape-5-mobile@2x.cd126dfd.png";